/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Inject, Injectable } from '@angular/core';
import { DialogService } from '@ng-falcon/dialog/dialog.service';
import { ArticleService } from '../../../../services/article.service';
import { CommentService } from '../../../../services/comment.service';
import { ConfirmActionDialogComponent, ConfirmActionDialogData } from './confirm-action-dialog.component';

// Moderator hide / show, shared by the Hide button (ut-community-hide-action) and the feed card's ⋯ menu.
@Injectable({ providedIn: 'root' })
export class HideItemService {
  constructor(
    @Inject('StatusService') private StatusService: any,
    @Inject('DiscussionService') private DiscussionService: any,
    private articleService: ArticleService,
    private commentService: CommentService,
    private dialogService: DialogService,
  ) {}

  // Asks first; resolves to whether the moderator confirmed.
  confirm(item: any): Promise<boolean> {
    const data: ConfirmActionDialogData = item.state === 'hidden'
      ? { title: 'Show this post?', text: 'It will be visible to the community again.', confirmLabel: 'Show' }
      : { title: 'Hide this post?', text: 'It will be hidden from the community. Moderators can still see it.', confirmLabel: 'Hide' };
    return new Promise((resolve) => {
      this.dialogService.open(ConfirmActionDialogComponent, { data }).afterClosed().subscribe((ok) => resolve(!!ok));
    });
  }

  // Flips item.state on the server and copies the result onto the item.
  toggle(item: any): Promise<void> {
    const service = {
      article: this.articleService,
      status: this.StatusService,
      comment: this.commentService,
      topic: this.DiscussionService,
    }[item.type];
    if (!service) return Promise.reject(new Error(`Can't hide a ${item.type}`));
    return service.toggleHide(item).then((res: any) => {
      Object.assign(item, res.data);
    });
  }
}
